export const steps = [
    {
        name : 'chooseColor',
        view : require('../views/ChooseColor').default
    },
    {
        name  : 'chooseMount',
        view : require('../views/ChooseMount').default
    },
    {
        name  : 'summary',
        view : require('../views/Summary').default
    }
]

export const language = $('html').attr('lang');

// export const colors = {
//     shade: {
//         basic: [
//             { name: 'black', label: 'black', color: '#2d2d2d' },
//             { name: 'white_9016', label: 'white_9016', color: '#fcfcfc', classes: "bordered dark-dot" },
//         ],
//         extra: [
//             { name: 'signalgelb_1003', label: 'signalgelb_1003', color: '#FBC800' },
//             { name: 'helrotorange_2008', label: 'helrotorange_2008', color: '#E27D02' },
//             { name: 'purpurrot_3004', label: 'purpurrot_3004', color: '#801400' },
//             { name: 'laubruen_6002', label: 'laubruen_6002', color: '#005E1F' },
//             { name: 'graubeige_1019', label: 'graubeige_1019', color: '#A2937C' },
//             { name: 'pastellblau_5024', label: 'pastellblau_5024', color: '#6990AD' },
//             { name: 'silbergrau_7001', label: 'silbergrau_7001', color: '#8C959C' },
//             { name: 'perlweiss_1013', label: 'perlweiss_1013', color: '#E5E0CA' },
//             { name: 'verkehrspurpur_4006', label: 'verkehrspurpur_4006', color: '#9D3D7D' },
//             { name: 'perlkupfer_8029', label: 'perlkupfer_8029', color: '#863B20', classes: "shiny" },
//             { name: 'perlgold_1036', label: 'perlgold_1036', color: '#886E3C', classes: "shiny"},
//             { name: 'perlmausgrau_7048', label: 'perlmausgrau_7048', color: '#83806D', classes: "shiny" },
//         ]
//     },
//     cable: {
//         unicolor: [
//             { name: 'einfarbig_schwarz', label: 'einfarbig_schwarz', color: '#2d2d2d' },
//             { name: 'einfarbig_weiss', label: 'einfarbig_weiss', color: '#fcfcfc', classes: "bordered dark-dot" },
//             { name: 'einfarbig_gelb', label: 'einfarbig_gelb', color: '#F6C202'},
//             { name: 'einfarbig_braun', label: 'einfarbig_braun', color: '#615046'},
//             { name: 'einfarbig_dunkelblau', label: 'einfarbig_dunkelblau', color: '#3B5EC4'},
//             { name: 'einfarbig_rot', label: 'einfarbig_rot', color: '#CA3334'},
//             { name: 'einfarbig_pink', label: 'einfarbig_pink', color: '#C86596'},
//             { name: 'einfarbig_gruen', label: 'einfarbig_gruen', color: '#26A025'},
//             { name: 'einfarbig_gold', label: 'einfarbig_gold', color: '#BC9B34'},
//         ],
//         pattern: [
//             { name: 'zickzack_rot-weiss', label: 'zickzack_rot_weiss', color: '#C50000', classes: "bg-red-white"},
//             { name: 'zickzack_schwarz-weiss', label: 'zickzack_schwarz_weiss', color: '#121212'},
//         ]
//     },
//     mount: [
//         { name: 'black', label: 'black', color: '#2d2d2d' },
//         { name: 'white', label: 'white', color: '#fcfcfc', classes: "bordered dark-dot" },
//     ]
// }

// export const mountTypes = [
//     { name: 'deckenronde', label: 'deckenronde' },
//     { name: 'stromschienenadapter', label: 'stromschienenadapter' },
//     { name: 'baldachin', label: 'deckenbaldachin' },
// ]
//
// export const initialState = {
//     currentStep: steps[0],
//     shadeColor: colors.shade.basic[0],
//     cableColor: colors.cable.unicolor[0],
//     mountColor: colors.mount[0],
//     mountType: mountTypes[0]
// }


// WEBPACK FOOTER //
// ./js/config/config.js